export default {
  text: {
    margin: [[7, 0, 7, 1]]
  },
  fieldWrapper: {
    height: 53
  },
  valueWrapper: {
    display: 'flex',
    alignItems: 'baseline'
  },
  label: {
    margin: 0
  },
  decoration: {
    margin: [[0, 0, 0, 7]]
  }
}
